import * as React from 'react'
import { TerminalNodeInterpreter } from '../model/TerminalNodeInterpreter';
import { TerminalScoreContext } from '../TerminalScoreProvider';
import TerminalStat from './TerminalStat';


type Props = {
  nodeId: string,
  className?: string
}

const MINIMUM_ACTIVE = 10;

const TerminalMinimumActiveChannelCount: React.FC<Props> = ({ nodeId, className = '' }) => {
  const { graph, terminalScore } = React.useContext(TerminalScoreContext);

  const graphNode = graph.getNode(nodeId);
  const terminalNode = terminalScore.getNode(nodeId);
  const interpreter = new TerminalNodeInterpreter(terminalNode);

  const activeChannelCount = graph.getActiveChannelIds(nodeId).length;
  const isBelowMinimum = activeChannelCount < MINIMUM_ACTIVE;

  return (
    <TerminalStat label="Active channels" value={activeChannelCount} isMatched={!isBelowMinimum} />

  );
}

export default TerminalMinimumActiveChannelCount;

